/**
 * Site Routes Registry
 * Central registry of all site pages for the Links Directory
 */

export const ROUTE_GROUPS = {
  CORE: 'Core Pages',
  BOOKS: 'Books',
  BOOK_READER: 'Book Reader & Apps',
  ARTICLES: 'Articles',
  COURSES: 'Self-Paced Courses',
  PUBLISHING: 'Publishing',
  ADMIN: 'Admin',
  AUTH: 'Authentication',
  LEGAL: 'Legal',
  OTHER: 'Other'
};

export const siteRoutes = [
  // Core Pages
  {
    id: 'home',
    name: 'Home',
    path: '/',
    group: ROUTE_GROUPS.CORE,
    description: 'Main landing page',
    isPublic: true
  },
  {
    id: 'about',
    name: 'About',
    path: '/about',
    group: ROUTE_GROUPS.CORE,
    description: 'About Promise Monday & Third Culture Leadership',
    isPublic: true
  },
  {
    id: 'contact',
    name: 'Contact',
    path: '/contact',
    group: ROUTE_GROUPS.CORE,
    description: 'Contact form and information',
    isPublic: true
  },
  {
    id: 'support',
    name: 'Support',
    path: '/support',
    group: ROUTE_GROUPS.CORE,
    description: 'Help and support center',
    isPublic: true
  },
  {
    id: 'speaking',
    name: 'Speaking',
    path: '/speaking',
    group: ROUTE_GROUPS.CORE,
    description: 'Speaking engagements and inquiries',
    isPublic: true
  },
  {
    id: 'calendar',
    name: 'Calendar',
    path: '/calendar',
    group: ROUTE_GROUPS.CORE,
    description: 'Events calendar',
    isPublic: true
  },
  {
    id: 'bio-links',
    name: 'Bio Links',
    path: '/bio-links',
    group: ROUTE_GROUPS.CORE,
    description: 'Social media link tree',
    isPublic: true
  },

  // Books
  {
    id: 'books',
    name: 'Books',
    path: '/books',
    group: ROUTE_GROUPS.BOOKS,
    description: 'Books hub with featured publications',
    isPublic: true
  },
  {
    id: 'books-hub',
    name: 'Books Hub',
    path: '/books/hub',
    group: ROUTE_GROUPS.BOOKS,
    description: 'All books directory',
    isPublic: true
  },
  {
    id: 'cultural-fluency-book',
    name: 'Cultural Fluency Book',
    path: '/books/cultural-fluency-without-compromise',
    group: ROUTE_GROUPS.BOOKS,
    description: 'Cultural Fluency Without Compromise book page',
    isPublic: true
  },
  {
    id: 'cultural-fluency-links',
    name: 'Book Buy Links',
    path: '/books/cultural-fluency-without-compromise/links',
    group: ROUTE_GROUPS.BOOKS,
    description: 'All purchase links for the book',
    isPublic: true
  },

  // Book Reader & Apps
  {
    id: 'book-reader',
    name: 'Web Reader',
    path: '/books/cultural-fluency-without-compromise/read',
    group: ROUTE_GROUPS.BOOK_READER,
    description: 'Online eBook reader',
    isPublic: true
  },
  {
    id: 'book-apps',
    name: 'Apps Hub',
    path: '/books/cultural-fluency-without-compromise/apps',
    group: ROUTE_GROUPS.BOOK_READER,
    description: 'Mobile apps download page',
    isPublic: true
  },
  {
    id: 'book-ios',
    name: 'iOS App',
    path: '/books/cultural-fluency-without-compromise/ios',
    group: ROUTE_GROUPS.BOOK_READER,
    description: 'iOS app page',
    isPublic: true
  },
  {
    id: 'book-android',
    name: 'Android App',
    path: '/books/cultural-fluency-without-compromise/android',
    group: ROUTE_GROUPS.BOOK_READER,
    description: 'Android app page',
    isPublic: true
  },
  {
    id: 'book-library',
    name: 'My Library',
    path: '/books/cultural-fluency-without-compromise/library',
    group: ROUTE_GROUPS.BOOK_READER,
    description: 'User library (post-purchase)',
    isPublic: true
  },
  {
    id: 'book-payment-success',
    name: 'Payment Success',
    path: '/books/cultural-fluency-without-compromise/payment-success',
    group: ROUTE_GROUPS.BOOK_READER,
    description: 'Payment confirmation page',
    isPublic: false
  },
  {
    id: 'book-payment-cancelled',
    name: 'Payment Cancelled',
    path: '/books/cultural-fluency-without-compromise/payment-cancelled',
    group: ROUTE_GROUPS.BOOK_READER,
    description: 'Payment cancellation page',
    isPublic: false
  },

  // Articles
  {
    id: 'articles',
    name: 'Articles',
    path: '/articles',
    group: ROUTE_GROUPS.ARTICLES,
    description: 'Blog articles and insights',
    isPublic: true
  },

  // Courses
  {
    id: 'courses',
    name: 'Self-Paced Courses',
    path: '/courses',
    group: ROUTE_GROUPS.COURSES,
    description: 'Online course modules',
    isPublic: true
  },
  {
    id: 'module-1',
    name: 'Module 1: Understanding Cultural Fluency',
    path: '/module-1',
    group: ROUTE_GROUPS.COURSES,
    description: 'Free foundational module',
    isPublic: true
  },
  {
    id: 'module-2',
    name: 'Module 2: Building Trust Across Cultures',
    path: '/module-2',
    group: ROUTE_GROUPS.COURSES,
    description: 'Premium module',
    isPublic: true
  },
  {
    id: 'module-3',
    name: 'Module 3: Leading with Cultural Clarity',
    path: '/module-3',
    group: ROUTE_GROUPS.COURSES,
    description: 'Premium module',
    isPublic: true
  },
  {
    id: 'module-4',
    name: 'Module 4: Turning Diversity Into Advantage',
    path: '/module-4',
    group: ROUTE_GROUPS.COURSES,
    description: 'Premium module',
    isPublic: true
  },
  {
    id: 'cfq-assessment',
    name: 'CFQ™ Assessment',
    path: '/cfq-assessment',
    group: ROUTE_GROUPS.COURSES,
    description: 'Cultural Fluency Quotient assessment',
    isPublic: true
  },
  {
    id: 'cfq-matrix',
    name: 'CFQ™ Matrix',
    path: '/cfq-matrix',
    group: ROUTE_GROUPS.COURSES,
    description: 'Cultural Fluency framework matrix',
    isPublic: true
  },
  {
    id: 'pillars',
    name: 'Three Pillars',
    path: '/pillars',
    group: ROUTE_GROUPS.COURSES,
    description: 'The three pillars of cultural fluency',
    isPublic: true
  },

  // Publishing
  {
    id: 'promond-publishing',
    name: 'Promond Publishing',
    path: '/promond-publishing',
    group: ROUTE_GROUPS.PUBLISHING,
    description: 'Publishing house page',
    isPublic: true
  },

  // Admin
  {
    id: 'admin',
    name: 'Admin Dashboard',
    path: '/admin',
    group: ROUTE_GROUPS.ADMIN,
    description: 'Admin control panel',
    isPublic: false
  },
  {
    id: 'admin-login',
    name: 'Admin Login',
    path: '/admin/login',
    group: ROUTE_GROUPS.ADMIN,
    description: 'Admin authentication',
    isPublic: false
  },
  {
    id: 'admin-invite',
    name: 'Accept Invite',
    path: '/admin/accept-invite',
    group: ROUTE_GROUPS.ADMIN,
    description: 'Admin invitation acceptance',
    isPublic: false
  },

  // Auth
  {
    id: 'signin',
    name: 'Sign In',
    path: '/signin',
    group: ROUTE_GROUPS.AUTH,
    description: 'Reader sign in',
    isPublic: true
  },
  {
    id: 'signup',
    name: 'Sign Up',
    path: '/signup',
    group: ROUTE_GROUPS.AUTH,
    description: 'Reader registration',
    isPublic: true
  },

  // Legal
  {
    id: 'privacy',
    name: 'Privacy Policy',
    path: '/privacy',
    group: ROUTE_GROUPS.LEGAL,
    description: 'Privacy policy and data handling',
    isPublic: true
  },
  {
    id: 'terms',
    name: 'Terms of Service',
    path: '/terms',
    group: ROUTE_GROUPS.LEGAL,
    description: 'Terms and conditions',
    isPublic: true
  },

  // Site Directory
  {
    id: 'links-directory',
    name: 'Site Directory',
    path: '/links',
    group: ROUTE_GROUPS.OTHER,
    description: 'All site pages with QR codes',
    isPublic: true
  },

  // Admin Links Manager
  {
    id: 'admin-links',
    name: 'Admin Links Manager',
    path: '/admin/links',
    group: ROUTE_GROUPS.ADMIN,
    description: 'Manage site directory entries',
    isPublic: false
  },

  // Legacy eBook (for reference)
  {
    id: 'ebook-landing',
    name: 'eBook Landing (Legacy)',
    path: '/ebook',
    group: ROUTE_GROUPS.OTHER,
    description: 'Legacy eBook landing page',
    isPublic: false
  }
];

export default siteRoutes;
